import React from "react";
import DashboardShell from "../Shared/DashboardShell";

// The advertiser's mirror of the broadcaster dashboard.
//
// This replaces a page that fetched bookings and ads and rendered both in one
// scroll, reached from nowhere -- there was no nav link to it. The advertiser
// side lived entirely in the top bar while the broadcaster side had a proper
// sidebar, so the two halves of the same product looked like two different
// applications.
//
// The tabs mirror the broadcaster's structure rather than its labels: what you
// own, what is happening, the money, you.
//
//     Broadcaster            Advertiser
//     My screens             My ads          -- what you bring
//     Payout & balance       Bookings        -- what is happening
//                            Payment methods -- the money
//     Profile                Profile

const TABS = [
    { to: "/customer/ads", label: "My ads" },
    // Campaigns sit above Bookings: a campaign is what was bought, a booking is
    // one screen inside it. The flat booking list stays for the per-screen
    // detail -- cancelling one screen, swapping one creative.
    { to: "/customer/campaigns", label: "Campaigns" },
    { to: "/customer/device-requests", label: "Bookings" },
    { to: "/customer/payment", label: "Payment methods" },
    { to: "/customer/profile", label: "Profile" },
];

export default function CustomerDashboard() {
    return <DashboardShell title="Advertiser" tabs={TABS} requires="customer_id" />;
}
